import {z} from 'zod';

const MIN_PRESENTATION_NAME_LENGTH = 3;
const MAX_PRESENTATION_NAME_LENGTH = 250;

export const presNameValidator = z
    .string()
    .trim()
    .min(MIN_PRESENTATION_NAME_LENGTH, `presentationName;min;${MIN_PRESENTATION_NAME_LENGTH}`)
    .max(MAX_PRESENTATION_NAME_LENGTH, `presentationName;max;${MAX_PRESENTATION_NAME_LENGTH}`);
